import { render, staticRenderFns } from "./areaPage.vue?vue&type=template&id=7ab470ba&scoped=true&"
import script from "./areaPage.vue?vue&type=script&lang=js&"
export * from "./areaPage.vue?vue&type=script&lang=js&"
import style0 from "./areaPage.vue?vue&type=style&index=0&id=7ab470ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab470ba",
  null
  
)

export default component.exports